import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import AuthCallback from '@/pages/AuthCallback';
import LandingPage from '@/pages/LandingPage';
import LoginPage from '@/pages/LoginPage';
import DashboardAcquereur from '@/pages/DashboardAcquereur';
import DashboardVendeur from '@/pages/DashboardVendeur';
import CreateSearchForm from '@/pages/CreateSearchForm';
import MessagingPage from '@/pages/MessagingPage';
import ProfilePage from '@/pages/ProfilePage';
import AdDetailPage from '@/pages/AdDetailPage';
import MonComptePage from '@/pages/MonComptePage';
import MesAnnoncesPage from '@/pages/MesAnnoncesPage';
import MesPropositionsPage from '@/pages/MesPropositionsPage';
import ProposalDetailPage from '@/pages/ProposalDetailPage';
import MyAdDetailPage from '@/pages/MyAdDetailPage';
import ProtectedRoute from '@/components/ProtectedRoute';
import '@/App.css';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<DashboardVendeur />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/ad/:adId" element={<AdDetailPage />} />
      <Route path="/proposal/:proposalId" element={<ProposalDetailPage />} />
      <Route path="/proposal/:proposalId" element={
        <ProtectedRoute>
          <ProposalDetailPage />
        </ProtectedRoute>
      } />
      <Route path="/my-ad/:adId" element={
        <ProtectedRoute>
          <MyAdDetailPage />
        </ProtectedRoute>
      } />
      <Route path="/mon-compte" element={<MonComptePage />} />
      <Route path="/mes-annonces" element={
        <ProtectedRoute>
          <MesAnnoncesPage />
        </ProtectedRoute>
      } />
      <Route path="/mes-propositions" element={
        <ProtectedRoute>
          <MesPropositionsPage />
        </ProtectedRoute>
      } />
      <Route path="/messagerie" element={
        <ProtectedRoute>
          <MessagingPage />
        </ProtectedRoute>
      } />
      
      <Route path="/dashboard-acquereur" element={
        <ProtectedRoute>
          <DashboardAcquereur />
        </ProtectedRoute>
      } />
      
      <Route path="/dashboard-vendeur" element={<DashboardVendeur />} />
      
      <Route path="/create-search" element={
        <ProtectedRoute>
          <CreateSearchForm />
        </ProtectedRoute>
      } />
      
      <Route path="/messages" element={
        <ProtectedRoute>
          <MessagingPage />
        </ProtectedRoute>
      } />
      
      <Route path="/profile" element={
        <ProtectedRoute>
          <ProfilePage />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
